import { Component, OnDestroy, OnInit } from '@angular/core'
import { NavService } from '../../services/nav.service'
import { KeyingAuthService } from '../../services/keying.auth.service'
import { AppRoutingConfig } from '../../configuration/app.routing.config'
import { Subject } from 'rxjs'
import { first, take, takeUntil } from 'rxjs/operators'
import { Loading, LoadingService } from '../../services/loading.service'
import { User } from '@overtur-monorepo/keying-user'
import { ActivatedRoute } from '@angular/router'
import { KeyingStructureService } from '../../services/keying.structure.service'
import { KeyingSystemService } from '../../services/keying.system.service'
import { KeyingDataSets, KeyingDataSetsService, KeySystemDataSets } from '../../services/keying.data.sets.service'
import { ThirdPartyNoticeComponent } from '@overtur-monorepo/phx-angular-material'
import { MatDialog } from '@angular/material/dialog'
import { KeySystem } from '../../models/dev.test.models'

@Component({
    selector: 'app-mk-structure',
    templateUrl: './structure.component.html',
    styleUrls: ['./structure.component.scss'],
    standalone: false
})
export class StructureComponent implements OnInit, OnDestroy {
  destroy$ = new Subject()
  loading: Loading
  structureId
  structure
  keySystem: KeySystem
  keySystemDataSets: KeySystemDataSets
  keyingDataSets: KeyingDataSets
  keywayFamily
  combinatingRule

  title = 'Keying'
  user: User

  userProfileActions = [{ name: 'logout', icon: 'logout', id: 0 }]

  helpActions = [
    { name: 'Support', icon: 'user', id: 0 },
    { name: 'Third party notice', icon: 'info', id: 1 },
  ]

  constructor(
    private navService: NavService,
    private keyingAuthService: KeyingAuthService,
    private loadingService: LoadingService,
    private route: ActivatedRoute,
    private keyingStructureService: KeyingStructureService,
    private keyingSystemService: KeyingSystemService,
    public keyingDataSetsService: KeyingDataSetsService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    /* istanbul ignore next */
    this.loadingService.loading$.pipe(takeUntil(this.destroy$)).subscribe((loading) => {
      this.loading = loading
    })

    /* istanbul ignore next */
    this.keyingAuthService.keyingUser$.pipe(takeUntil(this.destroy$)).subscribe((user) => {
      if (user) {
        this.user = user
        this.keyingAuthService.getUsers()
      }
    })

    this.route.params.pipe(first()).subscribe((res) => {
      this.structureId = res.structureId
      this.keyingStructureService.setStructureId(this.structureId)
      this.navService.setProfileActions(this.userProfileActions)
      this.navService.setHelpActions(this.helpActions)

      this.keyingStructureService
        .getStructure(this.structureId)
        .pipe(takeUntil(this.destroy$))
        .subscribe((structure) => {
          if (!structure) {
            return
          }
          this.keyingStructureService
            .getStructureKeySystems(structure.id)
            .pipe(take(1))
            .subscribe((keySystems) => {
              keySystems.forEach((keySystem) => {
                if (keySystem.keySectionId) {
                  this.keyingDataSetsService.setKeySectionName(structure, keySystem)
                }
              })
              structure.keySystems = keySystems
              this.keyingStructureService.selectStructure(structure)
            })
        })
    })

    this.keyingDataSetsService.keyingDataSets$
      .pipe(takeUntil(this.destroy$))
      .subscribe((keyingDataSets: KeyingDataSets) => {
        if (!keyingDataSets) {
          return
        }
        this.keyingDataSets = keyingDataSets
        this.keywayFamily = this.keyingDataSets.keywayFamilies.find((kwf) => kwf.id === this.structure?.keywayFamilyId)
        this.combinatingRule = this.keyingDataSets.combinatingRuleSets.find(
          (kwf) => kwf.id === this.structure?.combinatingRuleSetId
        )
      })

    /* istanbul ignore next */
    this.keyingStructureService.structure$.pipe(takeUntil(this.destroy$)).subscribe((structure) => {
      if (!structure) {
        return
      }
      this.structure = structure
    })
  }

  /* istanbul ignore next */
  ngOnDestroy() {
    this.destroy$.next(true)
    this.destroy$.complete()
  }

  /* istanbul ignore next */
  profileAction(action) {
    switch (action.id) {
      case 0:
        this.keyingAuthService.logout()
        break
      default:
        break
    }
  }

  /* istanbul ignore next */
  helpAction(action) {
    switch (action.id) {
      case 1:
        this.openLicenceFile()
        break
      default:
        break
    }
  }

  /* istanbul ignore next */
  openLicenceFile() {
    this.dialog.open(ThirdPartyNoticeComponent)
  }
}
